import React, { useState, useEffect } from "react";
import {
  EditBase,
  Form,
  TextInput,
  useNotify,
  useRecordContext,
  useRefresh,
} from "react-admin";
import { useLocation } from "react-router-dom";
import { Grid, IconButton, TextField } from "@mui/material";
import { validateAutoSaveSingleInput } from "../../../../Utils/AutoSave";
import {
  blockInvalidCharFromNumberInput,
  numberInputOnWheelPreventChange,
} from "../../../../Utils/ConversionUtils";
import { Search } from "@mui/icons-material";
import { getVehicleLookup } from "../../../../Utils/RestUtils";
import { TagPanel } from "../Panels";

const VehicleDetailsPanel = (props) => {
  const record = useRecordContext();
  const location = useLocation();
  const notify = useNotify();
  const refresh = useRefresh();
  const [image, setImage] = useState(
    record.leadContact.vehicle.vehicleInfo &&
      record.leadContact.vehicle.vehicleInfo.dvlaImage
  );
  const [reg, setReg] = useState(record.leadContact.vehicle.registration);

  const vinLookup = async () => {
    let vin = document.querySelector(
      '[name="leadContact.vehicle.vehicleInfo.vinNumber"]'
    );
    // remove unwanted chars
    let newVin = vin.value.replace(/[^a-zA-Z0-9]/g, "");

    if (newVin.length <= 2) {
      notify("VIN provided is not valid", { type: "error" });
      return;
    }

    const response = await getVehicleLookup({
      vin: newVin,
      quoteRequestId: record.id,
    });
    if (response.result === "error") {
      notify(response.error, { type: "error" });
    } else {
      refresh();
    }
  };

  const licensePlateLookup = async () => {
    const response = await getVehicleLookup({
      reg: reg,
      quoteRequestId: record.id,
    });
    if (response.result === "error") {
      notify(response.error, { type: "error" });
    } else {
      refresh();
    }
  };

  useEffect(() => {
    setImage(
      record.leadContact.vehicle.vehicleInfo &&
        record.leadContact.vehicle.vehicleInfo.dvlaImage
    );
  }, [location]);

  return (
    <EditBase>
      <Form>
        <Grid container spacing={1}>
          <Grid item flex={1}>
            <TextInput
              label="Vin"
              source="leadContact.vehicle.vehicleInfo.vinNumber"
              onInput={(e) =>
                (e.target.value = ("" + e.target.value).toUpperCase())
              }
              fullWidth
              InputProps={{
                endAdornment: (
                  <React.Fragment>
                    <IconButton
                      size="small"
                      aria-label="Search"
                      onClick={vinLookup}
                    >
                      <Search />
                    </IconButton>
                  </React.Fragment>
                ),
              }}
            />
          </Grid>
          <Grid item flex={1}>
            <TextInput
              name="leadContact.vehicle.registration"
              fullWidth
              label="Licence plate"
              onChange={(e) => setReg(e.target.value.toUpperCase())}
              InputProps={{
                endAdornment: (
                  <React.Fragment>
                    <IconButton
                      size="small"
                      aria-label="Search"
                      onClick={licensePlateLookup}
                    >
                      <Search />
                    </IconButton>
                  </React.Fragment>
                ),
              }}
            />
          </Grid>
        </Grid>
        <Grid container spacing={1}>
          <Grid item flex={1}>
            <TextInput
              name="leadContact.vehicle.make"
              fullWidth
              label="Make"
              value={record.leadContact.vehicle.make}
              onBlur={async (e) =>
                await validateAutoSaveSingleInput(
                  record,
                  e.target,
                  notify,
                  refresh
                )
              }
            />
          </Grid>
          <Grid item flex={2}>
            <TextInput
              name="leadContact.vehicle.model"
              fullWidth
              label="Model"
              value={record.leadContact.vehicle.model}
              onBlur={async (e) =>
                await validateAutoSaveSingleInput(
                  record,
                  e.target,
                  notify,
                  refresh
                )
              }
            />
          </Grid>
        </Grid>

        <Grid container spacing={1}>
          <Grid item flex={1}>
            <TextField
              name="leadContact.vehicle.vehicleInfo.aspiration"
              readOnly={true}
              label="Aspiration"
              fullWidth
              value={
                record.leadContact.vehicle.vehicleInfo &&
                record.leadContact.vehicle.vehicleInfo.aspiration
              }
            />
          </Grid>
          <Grid item flex={1}>
            <TextField
              name="leadContact.vehicle.vehicleInfo.engineModelCode"
              readOnly={true}
              label="Engine Code"
              fullWidth
              value={
                record.leadContact.vehicle.vehicleInfo &&
                record.leadContact.vehicle.vehicleInfo.engineModelCode
              }
            />
          </Grid>
          <Grid item flex={1}>
            <TextInput
              name="leadContact.vehicle.vehicleInfo.colour"
              fullWidth
              label="Color"
              value={
                record.leadContact.vehicle.vehicleInfo &&
                record.leadContact.vehicle.vehicleInfo.colour
              }
              onBlur={async (e) =>
                await validateAutoSaveSingleInput(
                  record,
                  e.target,
                  notify,
                  refresh
                )
              }
            />
          </Grid>
        </Grid>

        <Grid container spacing={1}>
          <Grid item flex={1}>
            <TextField
              name="leadContact.vehicle.vehicleInfo.modelSeries"
              readOnly={true}
              label="Series"
              fullWidth
              value={
                record.leadContact.vehicle.vehicleInfo &&
                record.leadContact.vehicle.vehicleInfo.modelSeries
              }
            />
          </Grid>
          <Grid item flex={1}>
            <TextField
              name="leadContact.vehicle.vehicleInfo.seats"
              readOnly={true}
              label="Seats"
              fullWidth
              value={
                record.leadContact.vehicle.vehicleInfo &&
                record.leadContact.vehicle.vehicleInfo.seats
              }
            />
          </Grid>
          <Grid item flex={1}>
            <TextField
              name="leadContact.vehicle.vehicleInfo.doors"
              fullWidth
              readOnly={true}
              label="Doors"
              value={
                record.leadContact.vehicle.vehicleInfo &&
                record.leadContact.vehicle.vehicleInfo.doors
              }
            />
          </Grid>
          <Grid item flex={1}>
            <TextField
              name="leadContact.vehicle.fuelType"
              fullWidth
              readOnly={true}
              label="Fuel"
              value={
                record.leadContact.vehicle.vehicleInfo &&
                record.leadContact.vehicle.fuelType
              }
            />
          </Grid>
        </Grid>

        <Grid container spacing={1}>
          <Grid item flex={1}>
            <TextField
              name="leadContact.vehicle.vehicleInfo.transmission"
              readOnly={true}
              label="Trans."
              fullWidth
              value={
                record.leadContact.vehicle.vehicleInfo &&
                record.leadContact.vehicle.vehicleInfo.transmission
              }
            />
          </Grid>
          <Grid item flex={1}>
            <TextField
              name="leadContact.vehicle.engineSize"
              readOnly={true}
              label="Engine CC"
              fullWidth
              value={
                record.leadContact.vehicle.vehicleInfo &&
                record.leadContact.vehicle.engineSize
              }
            />
          </Grid>
          <Grid item flex={1}>
            <TextInput
              name="leadContact.vehicle.vehicleInfo.kerbWeight"
              label="Kerb Weight"
              value={
                record.leadContact.vehicle.vehicleInfo &&
                record.leadContact.vehicle.vehicleInfo.kerbWeight
              }
              type={"number"}
              onWheel={numberInputOnWheelPreventChange}
              onKeyDown={blockInvalidCharFromNumberInput}
              onBlur={async (e) =>
                await validateAutoSaveSingleInput(
                  record,
                  e.target,
                  notify,
                  refresh
                )
              }
            />
          </Grid>
          <Grid item flex={1}>
            <TextField
              name="leadContact.vehicle.vehicleInfo.previousKeepers"
              label="Keepers"
              inputProps={{
                readOnly: true,
              }}
              fullWidth
              value={
                record.leadContact.vehicle.vehicleInfo &&
                record.leadContact.vehicle.vehicleInfo.previousKeepers
              }
            />
          </Grid>
        </Grid>

        <Grid container spacing={1}>
          <Grid item flex={2}>
            <TextField
              name="leadContact.vehicle.vehicleInfo.bodyStyle"
              readOnly={true}
              label="Body"
              fullWidth
              value={
                record.leadContact.vehicle.vehicleInfo &&
                record.leadContact.vehicle.vehicleInfo.bodyStyle
              }
            />
          </Grid>
          <Grid item flex={1}>
            <TextField
              name="leadContact.vehicle.vehicleInfo.registrationDate"
              readOnly={true}
              label="First reg."
              fullWidth
              value={
                record.leadContact.vehicle.vehicleInfo &&
                new Date(
                  record.leadContact.vehicle.vehicleInfo.registrationDate
                ).toLocaleDateString()
              }
            />
          </Grid>
        </Grid>
        <Grid sx={{ mb: 2 }}>
          <TagPanel {...props} />
        </Grid>
        <Grid sx={{ backgroundColor: "white" }}>
          <div
            style={{
              margin: "auto",
              height: "100px",
              width: "255px",
              backgroundImage: "url('" + image + "'), url('missing-image.png')",
              backgroundSize: "contain",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
            }}
          />
        </Grid>
      </Form>
    </EditBase>
  );
};

export default VehicleDetailsPanel;
